export default __webpack_public_path__ + "static/logo-dark-9ad589fd8ca5a8c22bee9a61af41d590.webp";